<template>
    <div style="border: 1px solid #dcdfe6;width: 800px;" v-if="trueOrFalse">
        <Toolbar
            style="border-bottom: 1px solid #ccc"
            :editor="editor"
            :defaultConfig="toolbarConfig"
            :mode="mode"
        />
        <Editor
            :style="{'height': height, 'overflow-y': 'hidden'}"
            v-model="htmls"
            :defaultConfig="editorConfig"
            :mode="mode"
            @onCreated="onCreated"
            @onChange="onChange"
        />
    </div>
</template>

<script>
import { UPLOAD_PATH, UPLOAD_API } from '@/utils/constant.js';
import { get, post, postJson, upload } from '@/utils/request.js';
import Vue from 'vue'
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { Boot } from '@wangeditor/editor'
import formulaModule from '@wangeditor/plugin-formula'

export default Vue.extend({
    components: { Editor, Toolbar },
    props: {
        height:{
            type: String,
            default: '500px'
        }
    },
    data() {
        return {
            editor: null,
            htmls: null,
            toolbarConfig: {
                "toolbarKeys": [
                    // "headerSelect",
                    // "blockquote",
                    "|",
                    "bold",
                    "underline",
                    "italic",
                    // {
                    //     "key": "group-more-style",
                    //     "title": "更多",
                    //     "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M204.8 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path><path d=\"M505.6 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path><path d=\"M806.4 505.6m-76.8 0a76.8 76.8 0 1 0 153.6 0 76.8 76.8 0 1 0-153.6 0Z\"></path></svg>",
                    //     "menuKeys": [
                    //         "through",
                    //         "code",
                    //         "sup",
                    //         "sub",
                    //         "clearStyle"
                    //     ]
                    // },
                    "color",
                    // "bgColor",
                    "|",
                    "fontSize",
                    // "fontFamily",
                    // "lineHeight",
                    "|",
                    // "bulletedList",
                    // "numberedList",
                    // "todo",
                    // {
                    //     "key": "group-justify",
                    //     "title": "对齐",
                    //     "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M768 793.6v102.4H51.2v-102.4h716.8z m204.8-230.4v102.4H51.2v-102.4h921.6z m-204.8-230.4v102.4H51.2v-102.4h716.8zM972.8 102.4v102.4H51.2V102.4h921.6z\"></path></svg>",
                    //     "menuKeys": [
                    //         "justifyLeft",
                    //         "justifyRight",
                    //         "justifyCenter",
                    //         "justifyJustify"
                    //     ]
                    // },
                    // {
                    //     "key": "group-indent",
                    //     "title": "缩进",
                    //     "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M0 64h1024v128H0z m384 192h640v128H384z m0 192h640v128H384z m0 192h640v128H384zM0 832h1024v128H0z m0-128V320l256 192z\"></path></svg>",
                    //     "menuKeys": [
                    //         "indent",
                    //         "delIndent"
                    //     ]
                    // },
                    "|",
                    // "emotion",
                    // "insertLink",
                    {
                        "key": "group-image",
                        "title": "图片",
                        "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M959.877 128l0.123 0.123v767.775l-0.123 0.122H64.102l-0.122-0.122V128.123l0.122-0.123h895.775zM960 64H64C28.795 64 0 92.795 0 128v768c0 35.205 28.795 64 64 64h896c35.205 0 64-28.795 64-64V128c0-35.205-28.795-64-64-64zM832 288.01c0 53.023-42.988 96.01-96.01 96.01s-96.01-42.987-96.01-96.01S682.967 192 735.99 192 832 234.988 832 288.01zM896 832H128V704l224.01-384 256 320h64l224.01-192z\"></path></svg>",
                        "menuKeys": [
                            "insertImage",
                            "uploadImage"
                        ]
                    },
                    // {
                    //     "key": "group-video",
                    //     "title": "视频",
                    //     "iconSvg": "<svg viewBox=\"0 0 1024 1024\"><path d=\"M981.184 160.096C837.568 139.456 678.848 128 512 128S186.432 139.456 42.816 160.096C15.296 267.808 0 386.848 0 512s15.264 244.16 42.816 351.904C186.464 884.544 345.152 896 512 896s325.568-11.456 469.184-32.096C1008.704 756.192 1024 637.152 1024 512s-15.264-244.16-42.816-351.904zM384 704V320l320 192-320 192z\"></path></svg>",
                    //     "menuKeys": [
                    //         "insertVideo",
                    //         "uploadVideo"
                    //     ]
                    // },
                    // "insertTable",
                    // "codeBlock",
                    // "divider",
                    // "|",
                    "undo",
                    "redo",
                    // "|",
                    // "fullScreen"
                ],
                // insertKeys: {
                //     index: 19, // 自定义
                //     keys: [
                //         'insertFormula', // “插入公式”菜单
                //         // 'editFormula' // “编辑公式”菜单
                //     ],
                // },
                "modalAppendToBody": false
            },
            trueOrFalse: false,
            editorConfig: {
                placeholder: '请输入内容...' ,
                MENU_CONF:{
                    uploadImage:{
                        fieldName: 'file',
                        server: UPLOAD_API + UPLOAD_PATH,
                        timeout: 5 * 1000,
                        metaWithUrl: true,
                        maxFileSize: 1000 * 1024 * 1024,
                        base64LimitSize: 0,
                        meta:{
                            token: localStorage.getItem('token')
                        },
                        async customUpload(files,insertFn){
                            var formData = new FormData();
                            formData.append("file", files, files.name);
                            await upload(UPLOAD_PATH,formData).then((da)=>{
                                if(da.success){
                                    insertFn(da.url)
                                }else {
                                    this.$message({
                                        message: da.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            })
                        }
                    },
                    uploadVideo:{
                        fieldName: 'file',
                        server: UPLOAD_API + "/mpp/file/upload",
                        timeout: 5 * 1000,
                        metaWithUrl: true,
                        base64LimitSize: 0,
                        meta:{
                            token: localStorage.getItem('token')
                        },
                        async customUpload(files,insertFn){
                            var formData = new FormData();
                            formData.append("file", files, files.name);
                            await upload("/mpp/file/upload",formData).then((da)=>{
                                if(da.success){
                                    insertFn(da.url)
                                }else {
                                    this.$message({
                                        message: da.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            })
                        }
                    },
                }
            },
            mode: 'default', // or 'simple'
        }
    },
    model: {
        prop: 'value',
        event: 'change'
    },
    created() {
        Boot.registerModule(formulaModule)
    },
    methods: {
        init(val){
            this.trueOrFalse = true
            this.htmls = null
            val = val.replace(/&lt;/g, '<');
            val = val.replace(/&gt;/g, '>');
            val = val.replace(/&quot;/g, '"');
            val = val.replace(/&nbsp;/g, " ");
            val = val.replace(/&ldquo;/g, '"');
            val = val.replace(/&rdquo;/g, '"');
            val = val.replace(/&amp;nbsp;/g, ' ');
            val = val.replace(/&amp;ldquo;/g, '"');
            val = val.replace(/&amp;rdquo;/g, '"');
            // val = val.replace(//)
            console.log("val111111111111111",val)
            this.htmls = val
        },
        onCreated(editor) {
            this.editor = Object.seal(editor) // 一定要用 Object.seal() ，否则会报错
            // 上传配置项
            let result = this.editor.getMenuConfig('uploadImage')
        },
        onChange(editor){
            console.log(editor.getHtml())
            this.$emit('change', editor.getHtml());
        },
        displays(){
            this.trueOrFalse = false;
        },
    },
    beforeDestroy() {
        const editor = this.editor
        if (editor == null) return
        editor.destroy() // 组件销毁时，及时销毁编辑器
    },
})
</script>

<style src="@wangeditor/editor/dist/css/style.css">

</style>
